import { Helmet } from "react-helmet";
import { useEffect, useRef } from "react";

function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { el.classList.add('visible'); obs.disconnect(); } }, { threshold: 0.15 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

const services = [
  {
    title: "Tally Certified Courses",
    desc: "Get certified by Tally Education Pvt. Ltd. (TEPL) — industry-recognized and valued by employers."
  },
  {
    title: "Learn, Earn & Grow Model",
    desc: "We help you learn skills, earn through opportunities, and grow in your career."
  },
  {
    title: "Expert Faculty",
    desc: "Trained professionals with real-world accounting & Tally experience."
  }
];


const Services = () => {
  const titleRef = useReveal();
  const cardsRef = useReveal();

      return(
  <>
           <Helmet>
        <title>Shrikant Tally Institute – Best Tally Certification in Damoh</title>
        <meta
          name="description"
          content="Join Shrikant Tally Institute for top Tally certification courses. Learn accounting, GST, and Tally ERP 9 from expert faculty in Damoh. Start your career in finance today."
        />
        <meta
          name="keywords"
          content="Shrikant Tally Institute, Tally course Damoh, Tally certification, Learn Tally, Accounting, GST, Purana Thana, Damoh, Tally Institute MP"
        />
        <meta property="og:title" content="Shrikant Tally Institute – Learn Tally ERP 9 in Damoh" />
        <meta property="og:description" content="Boost your career with certified Tally and GST training from Damoh's leading institute. Join Shrikant Tally Institute today." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://shrikanttallyinstitute.com/" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://shrikanttallyinstitute.com/" />
      </Helmet>
  <div className="container-fluid  px-3 px-md-5">
  

    {/* Services Cards */}
<div className="container-fluid  px-3 px-md-5">
  <div ref={titleRef} className="text-center mb-5 reveal">
    <h2 className="display-6 fw-bold mt-4">Why Choose Tally Certification?</h2>
    <p className="text-muted mx-auto mt-4" style={{ maxWidth: "800px" }}>
      Our platform helps build practical accounting skills essential for jobs in finance. Tally is widely used by businesses for managing accounts, inventory, GST, and payroll. Learning it enhances job opportunities as an accountant. A good platform offers hands-on training, real-life scenarios, and certifications to boost your career.
    </p>
  </div>

  {/* Services Cards */}
  <div ref={cardsRef} className="row justify-content-center g-4 reveal">
    {services.map((service, index) => (
      <div className="col-12 col-sm-6 col-md-4 col-lg-4" key={index}>
        <div
          className="card h-100 shadow-sm border-0"
          style={{ transition: "transform 0.3s ease, box-shadow 0.3s ease" }}
          onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "0 12px 28px rgba(0,0,0,0.12)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = ""; }}
        >
          <div className="card-body" style={{ background: '#ecf3d7' }}>
            <h5 className="card-title text-center text-success fw-semibold">{service.title}</h5>
            <p className="card-text text-center text-muted">{service.desc}</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

  </div>
  </>
);
}
export default Services;
